import store, { history } from '../../store';


export const initOneSignal = () => {

  if (window.plugins && window.plugins.OneSignal) {
    const storeUser = store.getState().user;
    console.log('Iniciando OneSignal...storeUser:', storeUser);


    const oneSignal = window.plugins.OneSignal;

    // disable location tracking
    // oneSignal.Location.setShared(false);

    // Enable verbose logging for debugging (remove in production)
    oneSignal.Debug.setLogLevel(6);

    // Initialize with your OneSignal App ID
    oneSignal.initialize('cbb922e1-cfa2-462d-b7a8-d23724e5b139');

    // Use this method to prompt for push notifications.
    // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
    oneSignal.Notifications.requestPermission(true).then((accepted) => {
      console.log("OneSignal init: User accepted notifications: " + accepted);
    });

    if (storeUser.user) {
      const aUser = storeUser.user;
      loginOneSignal(aUser);
    } else {
      logoutOneSignal();
    }

    window.plugins.OneSignal.Notifications.addEventListener("click", notificationOpenedCallback);

  }

}

const notificationOpenedCallback = (jsonData) => {
  console.log('OneSignal notificationOpenedCallback: ', jsonData);
  if (jsonData && jsonData.notification && jsonData.notification.additionalData) {
    const additionalData = jsonData.notification.additionalData;
    if (additionalData && additionalData.action) {
      console.log('OneSignal notification action:', additionalData.action, additionalData.route);

      if (additionalData.action == 'open') {
        console.log('...Opening route: ', additionalData.route);
        const route = `/#${additionalData.route}` || '/';
        window.location.href = route;
        history.push(route);
      }
    }
  }
};

export const loginOneSignal = (aUser) => {
  if (aUser && aUser.id && window.plugins && window.plugins.OneSignal) {
    console.log('OneSignal login aUser...:', aUser);
    const oneSignal = window.plugins.OneSignal;

    try {
      oneSignal.User.setLanguage(aUser.language);
      oneSignal.User.addEmail(aUser.email);
      oneSignal.User.removeTags(["nologged"]);
      oneSignal.User.addTag("age", `${aUser.age}`);
      oneSignal.User.addTag("name", `${aUser.name}`);
      oneSignal.login(`mis_${aUser.id}`);
    } catch (error) {
      console.error('Error logging in to OneSignal:', error);
    }
  }
}

export const logoutOneSignal = (userId) => {
  if (window.plugins && window.plugins.OneSignal) {
    console.log('OneSignal logOut...');
    const oneSignal = window.plugins.OneSignal;
    oneSignal.logout();
    try {
      oneSignal.User.removeTags(["age", "name"]);
      oneSignal.User.addTag("nologged", "1");
    } catch (error) {
      console.error('Error adding tag nologged:', error);
    }
  }
}

export const getOSId = async () => {
  if (window.plugins && window.plugins.OneSignal) {
    console.log('logOut OneSignal...');
    const oneSignal = window.plugins.OneSignal;
    const osId = await oneSignal.User.getOnesignalId();
  }
}